import { useCallback, useEffect, useRef, useState } from "react";
import { ISummaryItem, IUser } from "../../../types/api";
import MidPopup from "../../../hoc/MidPopup/MidPopup";
import { capitalizeWords, debounce } from "../../../shared/utility";
import { searchUsers } from "../../../api/users/users";
import { toast } from "react-toastify";
import "./BokasRemovalPopup.scss";
import MemberIdTag from "../../../components/UI/MemberIdTag/MemberIdTag";
import { expireBooking } from "../../../api/bookings/bookings";

interface IBokasRemovalPopupProps {
  onClose: () => void;
  showPopup: boolean;
  slot: ISummaryItem | null;
  onConfirm: () => void;
}
function BokasRemovalPopup(props: IBokasRemovalPopupProps) {
  const { onClose, showPopup, onConfirm } = props;
  const created_at = props.slot ? props.slot.booking[0].created_at : "";
  const minSinceBookingCreated =
    created_at && props.slot
      ? Math.floor(
          (Date.now() -
            new Date(
              created_at.replace(/(\+\d{2}:\d{2}):\d{2}$/, "$1"),
            ).getTime()) /
            60000,
        )
      : 0;

  const handleClose = () => {
    onClose();
  };

  const removeBokasBooking = async () => {
    if (!props.slot) return;

    const bookingData = {
      booking_id: props.slot.booking[0].booking_id || "",
      datetime_start: props.slot.booking[0].datetime_start,
      court_id: props.slot.booking[0].court_id,
      slot_index: props.slot.booking[0].slot_index,
      coach_id: [],
    };
    try {
      const deleteResponse = await expireBooking(bookingData);
      if (deleteResponse) {
        toast.success("Bokas bokning borttagen");
        onConfirm();
        onClose();
      }
    } catch (error) {
      console.error("Failed to remove Bokas booking:", error);
    }
  };

  return (
    <MidPopup
      onClose={() => handleClose()}
      showPopup={showPopup}
      leftTopElement={<span className="text-m">Bokas ruta</span>}
      onConfirm={() => {}}
    >
      {created_at ? (
        <div className="bokas-removal-popup-wrapper">
          {props.slot && (
            <div className="bokas-removal-popup-content text-m">
              <div>
                <span>Denna bokning initierades </span>
                {created_at.split("T")[0]} kl.{" "}
                {created_at.split("T")[1].split(".")[0]}
              </div>
              <div>
                <span>Minuter sedan boknings initiering: </span>
                {minSinceBookingCreated} minuter
              </div>
              <div>
                <span>Medlem på bokning: </span>
                {capitalizeWords(props.slot.booking[0].member_name)}{" "}
                <MemberIdTag memberId={props.slot.booking[0].member_id} />
              </div>
            </div>
          )}

          <button
            onClick={() => {
              removeBokasBooking();
            }}
            className="text-m danger-button"
            disabled={minSinceBookingCreated < 10}
          >
            Ta bort bokning
          </button>
        </div>
      ) : (
        <div className="bokas-removal-popup-wrapper">
          <div className="bokas-removal-popup-content text-m">
            Kunde inte hämta information om bokningen.
          </div>
        </div>
      )}
    </MidPopup>
  );
}

export default BokasRemovalPopup;
